function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-check

import { debounce } from '../common';

// TODO: Use IntersectionObserver instead of Scroll Event Listener
// Can track visibility of an element at the top of the page to determine
// if the page has been scrolled (e.g. skip-to-content link)
// and then update body attributes and header group based on
// visibility of the observed element

var constants = Object.freeze({
  none: 'none',
  "static": 'static',
  sticky: 'sticky',
  fixed: 'fixed',
  dynamic: 'dynamic',
  siteHeader: 'site-header',
  dynamicHidden: 'dynamic_hidden',
  umgSticky: 'umg-sticky',
  headerGroupSelector: '.shopify-section-group-header-group'
});

/**
 * Represents one header element within the header group
 */
var Header = /*#__PURE__*/function () {
  /**
   * @param {HTMLElement} element
   */
  function Header(element) {
    _classCallCheck(this, Header);
    /**
     * The matching header element
     * @type {HTMLElement}
     */
    this.element = element;

    /**
     * Expresses whether or not the header is of type SiteHeader
     * @type {boolean}
     */
    this.isSiteHeader = false;

    /**
     * Makes computed style of the header easily accessible
     * @type {CSSStyleDeclaration}
     */
    this.computedStyle = window.getComputedStyle(this.element);

    /**
     * Expresses whether or not the header is position: sticky
     * @type {boolean}
     */
    this.isSticky = this.computedStyle.position === constants.sticky;

    /**
     * Expresses whether or not the header is position: fixed
     * @type {boolean}
     */
    this.isFixed = this.computedStyle.position === constants.fixed;

    /**
     * Expresses whether or not the header is display: none
     * @type {boolean}
     */
    this.isHidden = this.computedStyle.display === constants.none;

    /**
     * Expresses whether or not the header is dynamically hidden (via transform: translate)
     * @type {boolean}
     */
    this.isDynamicHidden = false;
    this.resetStyles();
    this.resetVars();
  }

  /**
   * resets the header styles to build headers
   * @returns {void}
   */
  return _createClass(Header, [{
    key: "resetStyles",
    value: function resetStyles() {
      this.element.classList.remove(constants.dynamicHidden);
      this.element.style.transform = '';
      this.element.style.top = '';
      this.element.classList.add(constants.umgSticky, 'transition-[transform]');
    }

    /**
     * resets the header variables to build headers
     * @returns {void}
     */
  }, {
    key: "resetVars",
    value: function resetVars() {
      this.computedStyle = window.getComputedStyle(this.element);
      this.isSticky = this.computedStyle.position === constants.sticky;
      this.isFixed = this.computedStyle.position === constants.fixed;
      this.isHidden = this.computedStyle.display === constants.none;
      this.isDyanmicHidden = false;
    }

    /**
     * Dynamically shows the header element
     * @returns {void}
     */
  }, {
    key: "dynamicShow",
    value: function dynamicShow() {
      if (this.isSiteHeader || !this.isSticky) {
        this.element.classList.remove(constants.dynamicHidden);
        this.element.style.transform = "translateY(0)";
        this.isDynamicHidden = false;
      }
    }

    /**
     * Dynamically hides the header element
     * @returns {void}
     */
  }, {
    key: "dynamicHide",
    value: function dynamicHide() {
      if (this.isSiteHeader || !this.isSticky) {
        this.element.classList.add(constants.dynamicHidden);
        this.element.style.transform = "translateY(calc(-1 * var(--header-group-height)))";
        this.isDynamicHidden = true;
      }
    }
  }]);
}();
/**
 * Represents a main navigation site header
 * @extends {Header}
 */
var SiteHeader = /*#__PURE__*/function (_Header) {
  /**
   * @param {HTMLElement} element
   */
  function SiteHeader(element) {
    var _this;
    _classCallCheck(this, SiteHeader);
    _this = _callSuper(this, SiteHeader, [element]);
    _this.isSiteHeader = true;

    /**
     * The section wrapper of the site header contains position and behavior data
     * @type {HTMLElement?}
     */
    _this.wrapper = _this.element.querySelector('.header__wrapper');

    /**
     * Expresses whether or not this header is meant for tablet+ screens
     * @type {boolean}
     */
    _this.isMd = _this.wrapper === null ? false : _this.wrapper.classList.contains('header__wrapper--md');

    /**
     * Expresses the position and behavior settings derived from theme settings
     * @type {IBehaviors}
     */
    _this.behaviors = _this.setBehaviors();
    _this.updateHeaderPositions();
    _this.resetVars();
    return _this;
  }

  /**
   * Sets behaviors of the site header by parsing position data on the section wrapper
   * @returns {IBehaviors}
   */
  _inherits(SiteHeader, _Header);
  return _createClass(SiteHeader, [{
    key: "setBehaviors",
    value: function setBehaviors() {
      var _this$wrapper$dataset, _this$wrapper, _behaviorString$split;
      /** @type {IBehaviors} */
      var behaviors = {
        dynamic: false,
        headerPosition: constants["static"],
        groupPosition: constants["static"]
      };
      var behaviorString = (_this$wrapper$dataset = (_this$wrapper = this.wrapper) === null || _this$wrapper === void 0 ? void 0 : _this$wrapper.dataset.position) !== null && _this$wrapper$dataset !== void 0 ? _this$wrapper$dataset : null;
      var _ref = (_behaviorString$split = behaviorString === null || behaviorString === void 0 ? void 0 : behaviorString.split('_')) !== null && _behaviorString$split !== void 0 ? _behaviorString$split : [null, null],
        _ref2 = _slicedToArray(_ref, 2),
        dynamicPart = _ref2[0],
        positionPart = _ref2[1];
      if (!dynamicPart || !positionPart) return behaviors;
      behaviors.dynamic = dynamicPart === constants.dynamic;
      behaviors.headerPosition = positionPart;
      behaviors.groupPosition = positionPart === constants.fixed ? constants.fixed : constants["static"];
      return behaviors;
    }

    /**
     * Updates css variables for site header and header group positions
     * @returns {void}
     */
  }, {
    key: "updateHeaderPositions",
    value: function updateHeaderPositions() {
      var modifier = this.isMd ? '-md' : '';
      document.body.style.setProperty("--header-group-header-position".concat(modifier), this.behaviors.headerPosition);
      document.body.style.setProperty("--header-group-position".concat(modifier), this.behaviors.groupPosition);
    }
  }]);
}(Header);
/**
 * Represents a sticky element in the DOM
 */
var StickyElement = /*#__PURE__*/_createClass(
/**
 * @constructor
 * @param {HTMLElement} element
 */
function StickyElement(element) {
  _classCallCheck(this, StickyElement);
  this.element = element;
  this.computedStyle = window.getComputedStyle(this.element);
  this.isHidden = this.computedStyle.display === constants.none;
  this.isSticky = this.computedStyle.position === constants.sticky;
  this.isFixed = this.computedStyle.position === constants.fixed;
});
/**
 * Represents all header elements as a single group
 */
var HeaderGroup = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param {Header[]} headers
   */
  function HeaderGroup(headers) {
    _classCallCheck(this, HeaderGroup);
    /**
     * The collection of Headers within the header group
     * @type {Header[]}
     */
    this.headers = headers;

    /**
     * The collection of SiteHeaders within the header group's headers
     * @type {SiteHeader[]}
     */
    this.siteHeaders = /** @type {SiteHeader[]} */this.headers.filter(function (header) {
      return header.isSiteHeader;
    });

    /**
     * The collection of all sticky elements in the document
     * @type {StickyElement[]}
     */
    this.stickyElements = [];

    /**
     * Expresses whether or not the header group contains a fixed header
     * @type {boolean}
     */
    this.fixedGroup = this.siteHeadersBehave('headerPosition', 'fixed');

    /**
     * Expresses whether or not the header group has dynamic headers
     * @type {boolean}
     */
    this.hasDynamicHeaders = this.siteHeadersBehave('dynamic', true);

    /**
     * The collection of target headers to dynamically hide / show on scroll up / down
     * In the case that the header group contains a dynamic header
     * @type {Header[]}
     */
    this.dynamicTargets = [];

    /**
     * The scroll event callback to be stored so that it can also be removed when headers are rebuilt
     * @type {EventListener?}
     */
    this.scrollEventCallback = null;
  }

  /**
   * Returns whether or not header group site headers have a certain behavior value
   * @param {string} name - the name of the behavior
   * @param {any} value
   * @returns {boolean}
   */
  return _createClass(HeaderGroup, [{
    key: "siteHeadersBehave",
    value: function siteHeadersBehave(name, value) {
      var _iterator = _createForOfIteratorHelper(this.siteHeaders),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var header = _step.value;
          if (!header.isHidden && header.behaviors[name] === value) {
            return true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return false;
    }

    /**
     * Dynamically hides all headers within the group's dynamic targets
     * @returns {void}
     */
  }, {
    key: "hideDynamicTargets",
    value: function hideDynamicTargets() {
      var _iterator2 = _createForOfIteratorHelper(this.dynamicTargets),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var target = _step2.value;
          target.dynamicHide();
          this.updateMeasurements();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }

    /**
     * Dynamically show all headers within the group's dynamic targets
     * @returns {void}
     */
  }, {
    key: "showDynamicTargets",
    value: function showDynamicTargets() {
      var _iterator3 = _createForOfIteratorHelper(this.dynamicTargets),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var target = _step3.value;
          target.dynamicShow();
          this.updateMeasurements();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }

    /**
     * Updates the measurements of the header group on the initial run
     * @returns {void}
     */
  }, {
    key: "updateInitialMeasurements",
    value: function updateInitialMeasurements() {
      return this.updateMeasurements(true);
    }

    /**
     * Sets css variables that control fixed and sticky heights of header group elements
     * @param {boolean} isInitRun - (optional) whether this is the initial run, will reset header initial indices. default is `false`.
     * @returns {void}
     */
  }, {
    key: "updateMeasurements",
    value: function updateMeasurements() {
      var isInitRun = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var headerGroupHeight = 0;
      var headerVisibleHeight = 0;
      var headerStickyHeight = 0;
      var i = 0;
      var elementsChecked = [];
      var _iterator4 = _createForOfIteratorHelper(this.headers),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var header = _step4.value;
          if (!header.isHidden) {
            var headerHeight = header.element.offsetHeight;
            if (headerHeight === 0) {
              var _header$element$query, _header$element$query2;
              headerHeight = (_header$element$query = (_header$element$query2 = header.element.querySelector('div')) === null || _header$element$query2 === void 0 ? void 0 : _header$element$query2.offsetHeight) !== null && _header$element$query !== void 0 ? _header$element$query : 0;
            }
            headerGroupHeight += headerHeight;
            if (!header.isDynamicHidden) {
              headerVisibleHeight += headerHeight;
              if (header.isSticky || header.isFixed) {
                headerStickyHeight += headerHeight;
              }
            }
            document.body.style.setProperty("--header-item-height-".concat(i), headerVisibleHeight + 'px');
            document.body.style.setProperty("--header-item-sticky-height-".concat(i), headerStickyHeight + 'px');
            header.element.style.top = i === 0 ? '0' : header.isSticky ? "var(--header-item-sticky-height-".concat(i - 1, ")") : "var(--header-item-height-".concat(i - 1, ")");
            i++;
          }
          elementsChecked.push(header.element);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      var _iterator5 = _createForOfIteratorHelper(this.stickyElements),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var stickyElement = _step5.value;
          if (!elementsChecked.includes(stickyElement.element)) {
            if (!stickyElement.isHidden) {
              var _headerHeight = stickyElement.element.offsetHeight;
              if (_headerHeight === 0) {
                var _stickyElement$elemen, _stickyElement$elemen2;
                _headerHeight = (_stickyElement$elemen = (_stickyElement$elemen2 = stickyElement.element.querySelector('div')) === null || _stickyElement$elemen2 === void 0 ? void 0 : _stickyElement$elemen2.offsetHeight) !== null && _stickyElement$elemen !== void 0 ? _stickyElement$elemen : 0;
              }
              if (stickyElement.isSticky || stickyElement.isFixed) {
                headerStickyHeight += _headerHeight;
              }
              document.body.style.setProperty("--header-item-sticky-height-".concat(i), headerStickyHeight + 'px');
              stickyElement.element.style.top = i === 0 ? '0' : "var(--header-item-sticky-height-".concat(i - 1, ")");
              i++;
            }
            elementsChecked.push(stickyElement.element);
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      document.body.style.setProperty('--header-group-height', headerGroupHeight + 'px');
      document.body.style.setProperty('--header-sticky-height', headerStickyHeight + 'px');
      if (isInitRun) {
        document.body.style.setProperty('--header-group-height-init', headerGroupHeight + 'px');
      }
    }

    /**
     * Sets the scroll listener for headers
     * @returns {void}
     */
  }, {
    key: "setScrollListener",
    value: function setScrollListener() {
      var initialScrollPosition = window.scrollY;
      var _iterator6 = _createForOfIteratorHelper(this.siteHeaders),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var header = _step6.value;
          var isDynamicHeader = header.isSiteHeader && header.behaviors.dynamic;
          if (!header.isHidden && isDynamicHeader) {
            this.dynamicTargets = header.isFixed ? this.headers : [header];
            this.scrollEventCallback = scrollEventListener(initialScrollPosition, this);
            window.addEventListener('scroll', this.scrollEventCallback, {
              passive: true
            });
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
  }]);
}();
/**
 * A singleton that manages the header group
 *
 * @example
 * const headerGroupManager = HeaderGroupManager.getInstance()
 */
export var HeaderGroupManager = /*#__PURE__*/function () {
  /**
   * @private
   */
  function HeaderGroupManager() {
    var _this2 = this;
    _classCallCheck(this, HeaderGroupManager);
    /**
     * The header group
     * @type {HeaderGroup?}
     */
    this.headerGroup = null;

    /**
     * The collection of all sticky elements in the document
     * @type {StickyElement[]}
     */
    this.stickyElements = [];
    document.addEventListener('DOMContentLoaded', function () {
      return _this2.buildInitialHeaders();
    });
    window.addEventListener('resize', debounce(function () {
      return _this2.buildHeaders(false);
    }, 100));
    // @ts-expect-error - Shopify global
    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', function () {
        return _this2.buildInitialHeaders();
      });
      document.addEventListener('shopify:section:unload', function () {
        return _this2.buildInitialHeaders();
      });
      document.addEventListener('shopify:section:reorder', function () {
        return _this2.buildInitialHeaders();
      });
    }
  }

  /**
   * Returns the singleton instance of the header group manager
   * @returns {HeaderGroupManager}
   */
  return _createClass(HeaderGroupManager, [{
    key: "buildInitialHeaders",
    value:
    /**
     * Builds the initial headers
     * @returns {void}
     */
    function buildInitialHeaders() {
      return this.buildHeaders(true);
    }

    /**
     * Primary trigger function, rebuilds the entire header group
     * @param {boolean} isInitRun - whether this is the initial run, will reset header initial indices
     * @returns {void}
     */
  }, {
    key: "buildHeaders",
    value: function buildHeaders() {
      var _this$headerGroup;
      var isInitRun = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if ((_this$headerGroup = this.headerGroup) !== null && _this$headerGroup !== void 0 && _this$headerGroup.scrollEventCallback) {
        window.removeEventListener('scroll', this.headerGroup.scrollEventCallback);
      }

      /** @type {NodeListOf<HTMLElement>} */
      var headerGroupElements = document.querySelectorAll(constants.headerGroupSelector);
      var headerGroupArray = [];
      var _iterator7 = _createForOfIteratorHelper(headerGroupElements.entries()),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var _step7$value = _slicedToArray(_step7.value, 2),
            index = _step7$value[0],
            headerElement = _step7$value[1];
          var header = headerElement.classList.contains(constants.siteHeader) ? new SiteHeader(headerElement) : new Header(headerElement);
          if (isInitRun) {
            header.element.dataset.initialIndex = index.toString();
          }
          headerGroupArray.push(header);
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
      var headerGroup = new HeaderGroup(headerGroupArray);
      this.stickyHeaderOrderManager(headerGroup);
      headerGroup.updateInitialMeasurements();
      if (headerGroup.hasDynamicHeaders) {
        headerGroup.setScrollListener();
      }
      this.headerGroup = headerGroup;
      this.setStickyElements();
      this.headerGroup.stickyElements = this.stickyElements;
    }

    /**
     * Collect sticky elements on the DOM into the stickyElements collection
     * @returns {void}
     */
  }, {
    key: "setStickyElements",
    value: function setStickyElements() {
      var stickyElements = /** @type {HTMLElement[]} */Array.from(document.querySelectorAll('.' + constants.umgSticky)).filter(function (element) {
        return window.getComputedStyle(element).position === constants.sticky;
      });
      var stickyElementsArray = [];
      var _iterator8 = _createForOfIteratorHelper(stickyElements),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var element = _step8.value;
          stickyElementsArray.push(new StickyElement(element));
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
      this.stickyElements = stickyElementsArray;
    }

    /**
     * If a header is sticky and the header group is fixed
     * then move the header to the top of the header group
     * otherwise, move it back to where it was initially
     * @param {HeaderGroup} headerGroup
     * @returns {void}
     */
  }, {
    key: "stickyHeaderOrderManager",
    value: function stickyHeaderOrderManager(headerGroup) {
      if (headerGroup != null) {
        var staticIndexModifier = 0;
        var _iterator9 = _createForOfIteratorHelper(_toConsumableArray(headerGroup.headers).reverse()),
          _step9;
        try {
          for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
            var header = _step9.value;
            headerGroup.headers.splice(headerGroup.headers.indexOf(header), 1);
            if (headerGroup.fixedGroup && header.isSticky) {
              headerGroup.headers.unshift(header);
              staticIndexModifier += 1;
            } else {
              var indexToSplice = header.element.dataset.initialIndex;
              if (!indexToSplice) return;
              headerGroup.headers.splice(parseInt(indexToSplice, 10) + staticIndexModifier, 0, header);
            }
          }
        } catch (err) {
          _iterator9.e(err);
        } finally {
          _iterator9.f();
        }
      }
    }

    /**
     * Updates the measurements of the header group
     * @returns {void}
     */
  }, {
    key: "updateMeasurements",
    value: function updateMeasurements() {
      var _this$headerGroup2;
      return (_this$headerGroup2 = this.headerGroup) === null || _this$headerGroup2 === void 0 ? void 0 : _this$headerGroup2.updateMeasurements();
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!HeaderGroupManager.instance) {
        HeaderGroupManager.instance = new HeaderGroupManager();
      }
      return HeaderGroupManager.instance;
    }
  }]);
}();

/**
 * @type {HeaderGroupManager?}
 */
HeaderGroupManager.instance = null;

/**
 * On scroll up, move dynamic header group elements out of view
 * On scroll down, bring the elements back into view
 * @param {number} initialScrollPosition
 * @param {HeaderGroup} headerGroup
 * @returns {EventListener}
 */
var scrollEventListener = function scrollEventListener(initialScrollPosition, headerGroup) {
  var previousScrollPosition = initialScrollPosition;
  return function () {
    var currentScrollPosition = window.scrollY;
    var isScrollingUp = previousScrollPosition > currentScrollPosition;
    document.body.dataset.scrolled = String(window.scrollY > 0);

    /** @type {NodeListOf<HTMLElement & {close: () => void}>} */
    var predictiveSearches = document.querySelectorAll('.' + constants.siteHeader + ' predictive-search');
    var _iterator10 = _createForOfIteratorHelper(predictiveSearches),
      _step10;
    try {
      for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
        var search = _step10.value;
        search.close();
      }
    } catch (err) {
      _iterator10.e(err);
    } finally {
      _iterator10.f();
    }
    if (isScrollingUp && document.body.dataset.scrollDirection !== 'up') {
      headerGroup.showDynamicTargets();
      document.body.dataset.scrollDirection = 'up';
    } else if (!isScrollingUp && document.body.dataset.scrollDirection !== 'down') {
      // Hide header if we arent at the top of the page
      if (window.scrollY <= 0) return;
      headerGroup.hideDynamicTargets();
      document.body.dataset.scrollDirection = 'down';
    }
    previousScrollPosition = currentScrollPosition;
  };
};

/**
 * @typedef {{
 *   dynamic: boolean,
 *   headerPosition: string,
 *   groupPosition: string,
 * }} IBehaviors
 */